import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OktaAuthService } from '@okta/okta-angular';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../logger/logger.service';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { JsonDocCreateResponse } from './json-doc-create-response';
import { NewRegistrationDataCollectionService } from '../registration/newRegistration-data-collection.service';

@Injectable({
  providedIn: 'root'
})
export class UploaddocumentService {


  baseurl = environment.baseUrlRegistration;
  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    body: {
      reasonForDelete: 'Deleting from RC',
    },
  };
  constructor(
    private http: HttpClient, public oktaAuth: OktaAuthService,
    private loggerService: LoggerService, private dataCollectionService: NewRegistrationDataCollectionService) { }

  private documentTypeSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  documentType$: Observable<any> = this.documentTypeSubject.asObservable();


  private fileToUploadSubject: BehaviorSubject<File> = new BehaviorSubject<File>(null);
  fileToUpload$: Observable<File> = this.fileToUploadSubject.asObservable();

  // Post file
  postFile$ = combineLatest([this.dataCollectionService.selectedTransactionGUID$, this.documentType$, this.fileToUpload$]).pipe(
    tap(x => console.log('Tapping out postFile', x)),
    switchMap(([transactionId, documentType, file]) => {
      const formData: FormData = new FormData();
      formData.append('AttachedFile', file);
      formData.append('DocumentTypeCode', documentType);
      return this.http.post<JsonDocCreateResponse>(this.baseurl + '/' + transactionId + '/documents', formData,
      );
    }),
    tap(x => console.log('Tapping out postFile switchMap', x))
  );



  private selectedDocumentIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  selectedDocumentId$: Observable<string> = this.selectedDocumentIdSubject.asObservable();

  // Get multiple file
  getDocuments$ = this.dataCollectionService.selectedTransactionGUID$.pipe(
    switchMap(transactionId => this.http.get(this.baseurl + '/' + transactionId + '/documents'))
  );

  // Get file
  getDocument$ = combineLatest([this.dataCollectionService.selectedTransactionGUID$, this.selectedDocumentId$]).pipe(
    switchMap(([transactionId, documentId]) => this.http.get(this.baseurl + '/' + transactionId + '/documents/' + documentId,
      { responseType: 'blob' }))
  ).pipe(
    tap(x => console.log('Combined Latest to download attachment'))
  );



  private deleteDocumentIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  deleteDocumentId$: Observable<string> = this.deleteDocumentIdSubject.asObservable();

  // Delete file
  deleteDocument$ = combineLatest([this.dataCollectionService.selectedTransactionGUID$, this.deleteDocumentId$]).pipe(
    switchMap(([transactionId, documentId]) => {
      return this.http.delete(this.baseurl + '/' + transactionId + '/documents/' + documentId, this.options);
    })
  );

  delete(documentId) {
    this.deleteDocumentIdSubject.next(documentId);
  }
  postDocument(documentType, file) {
    this.documentTypeSubject.next(documentType);
    this.fileToUploadSubject.next(file);
  }

  setDocumentID(documentId?) {
    if (documentId) {
      this.selectedDocumentIdSubject.next(documentId);
    }
  }

  setDocumentType(documentTypeCode: string) {
    this.documentTypeSubject.next(documentTypeCode);
  }

  uploadDocument(transactionGuid: string, documentType: string, file: File, comment: string, sectionName: string) {
    const fileToUpload = file;
    const formData: FormData = new FormData();

    formData.append('AttachedFile', fileToUpload, fileToUpload.name);
    formData.append('DocumentTypeCode', '' + documentType);
    formData.append('comment', '' + comment);
    formData.append('sectionName', '' + sectionName);

    return this.http.post<JsonDocCreateResponse>(`${this.baseurl}/${transactionGuid}/documents`, formData);
  }

  deleteDocument(transactionGuid: string, documentId: string) {
    return this.http.delete(`${this.baseurl}/${transactionGuid}/documents/${documentId}`, this.options);
  }

  viewDocument(transactionGuid: string, documentId: string) {
    return this.http.get(`${this.baseurl}/${transactionGuid}/documents/${documentId}`, { responseType: 'blob' });
  }
}

